'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var React = _interopRequireWildcard(_react);

var _bind = require('classnames/bind');

var _bind2 = _interopRequireDefault(_bind);

var _style = require('./style.css');

var _style2 = _interopRequireDefault(_style);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

var cx = _bind2.default.bind(_style2.default);

var isSingleVisibleChild = function isSingleVisibleChild(children) {
  return React.Children.toArray(children).filter(Boolean).length === 1;
};

var FormFooter = function FormFooter(_ref) {
  var children = _ref.children,
      _ref$down = _ref.down,
      down = _ref$down === undefined ? true : _ref$down,
      _ref$sticky = _ref.sticky,
      sticky = _ref$sticky === undefined ? false : _ref$sticky,
      _ref$ignoreCentered = _ref.ignoreCentered,
      ignoreCentered = _ref$ignoreCentered === undefined ? false : _ref$ignoreCentered;
  var needCentered = !ignoreCentered && isSingleVisibleChild(children);
  return React.createElement('div', {
    className: cx('xsui-form-footer', down && 'xsui-form-footer--down', sticky && 'xsui-form-footer--sticky', needCentered && 'xsui-form-footer--centered')
  }, React.createElement('div', {
    className: cx('xsui-form-footer__entry')
  }, children));
};

FormFooter.propTypes = {
  children: _propTypes2.default.node.isRequired,
  down: _propTypes2.default.bool,
  sticky: _propTypes2.default.bool,
  ignoreCentered: _propTypes2.default.bool
};
exports.default = FormFooter;